
import { TYPE_QUESTIONS, useGameSounds, useMediaQuery } from "@educaplay/core";
import InputWithButton from "../../InputWithButton";
import Point from "../../Point";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect, useCallback } from "react"
import { goToQuestion, setShowBankControl } from "@educaplay/store/slices/gameSlice";
import { Fill } from "@educaplay/core/components";
import useMap from "../../../hooks/useMap";
import { MAPA_SOUNDS, STATE_POINT, TYPE_POINTS } from "../../../utils/constants";
import InputTopWithButtons from "../../InputTopWithButtons";
import { isUnansweredAnswer } from "@educaplay/store/utils/functions";
import { DialogContent } from "../../DialogContent";
import SwipeableDrawerPoint from "../../SwipeableDrawerPoint";
import useNavigationQuestion from "../../../hooks/useNavigationQuestion";

const DELAY_SHOW_WRONG = 600;
const DELAY_RESET_WRONG_STATE = 1000;
const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const InteractivePointText = (props) => {
  const { id, onAnswer, disabled, isCurrentQuestion, onClick, passScreenHandler, setIsInfoScreenActive, isInfoScreenActive, setIsInputOpen } = props;
  const allQuestions = useSelector(state => state.game.questions);
  const [showInput, setShowInput] = useState(false);
  const screenId = useSelector(state => state.game.questions[state.game.currentIndex].screenId);  
  const questions = allQuestions.filter(question => question.screenId === screenId);
  const [showInfoDialog, setShowInfoDialog] = useState(false);
  const dispatch = useDispatch();
  const currentQuestion = useSelector(state => state.game.questions[state.game.currentIndex]);
  const [hasAcert, setHasAcert] = useState(false);
  const pointDisabled = disabled;
  const [state, setState] = useState(STATE_POINT.DEFAULT);
  const questionSelected = questions.find(question => question.id === id);
  const isTouchDevice = (useMediaQuery("(hover:none)") || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0));
  const [showBalloon, setShowBalloon] = useState(true);
  const gameSound = useGameSounds();
  const isAllscreenPointsVisited = questions.every(question => !isUnansweredAnswer(question.answer,{examMode: false}) && question.checkAnswer(question.answer));
  const isLastPointVisited = questions.filter(question => !isUnansweredAnswer(question.answer,{examMode: false}) && question.checkAnswer(question.answer)).length === questions.length - 1;
  const { onChangeEnablePassQuestion } = useNavigationQuestion();
  const liveActived = useSelector(state => state.game.liveActived);


  const { zoomToPoint } = useMap();

  useEffect(() => {
    dispatch(setShowBankControl(false))
    setIsInfoScreenActive(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const findNextQuestionIndex = () => {
    if (questions.length === 1) return;
    const currentIndex = questions.findIndex(question => question.id === currentQuestion.id);
    const questionsOrdered = [...questions.slice(currentIndex + 1), ...questions.slice(0, currentIndex)]
    const nextQuestion = questionsOrdered.find((question) => isUnansweredAnswer(question.answer) || (!isUnansweredAnswer(question.answer) && !question.checkAnswer(question.answer)));
    const nextQuestionIndex = (nextQuestion) ?
      allQuestions.findIndex(({ id }) => id === nextQuestion.id) :
      allQuestions.findIndex((question) => question.id === questions.find(({ id }) => id !== currentQuestion.id).id);
    return nextQuestionIndex;
  }

  const nextQuestionIndex = findNextQuestionIndex();

  const handleClose = useCallback(() => {
    onChangeEnablePassQuestion(true);
    setShowInput(false);
    setIsInfoScreenActive(false);
    dispatch(setShowBankControl(false));
    onClick(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  useEffect(() => {
    const closeInput = () => {
      handleClose()
    }

    if (showInput) {
      window.addEventListener("map-click", closeInput);

      return () => {
        window.removeEventListener("map-click", closeInput);
      }
    }
  }, [showInput, handleClose])

  useEffect(() => {
    if (!isCurrentQuestion) return;

    const init = async () => {
      gameSound.play(MAPA_SOUNDS.GOODACTIVE);
      dispatch(setShowBankControl(true))
      setShowInput(true);
      await zoomToPoint(currentQuestion);
    }
    init();

    return () => {
      setShowInput(false);
    }
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [isCurrentQuestion, hasAcert, currentQuestion, zoomToPoint, dispatch, gameSound])


  const clickHandler = async () => {

    if (hasAcert) {
      onChangeEnablePassQuestion(false);
      onClick(null);
      dispatch(goToQuestion(allQuestions.findIndex(question => question.id === questionSelected.id)));
      zoomToPoint(questionSelected);
      await wait(200);
      setShowInfoDialog(true);
      setIsInfoScreenActive(true);
      return;
    }

    onClick(id);
    const selectedIndex = allQuestions.findIndex(question => question.id === id);
    dispatch(goToQuestion(selectedIndex));
  }

  const submitHandler = (answer) => {
    onClick(null);
    setShowInput(false);
    setIsInfoScreenActive(false);

    const userAnswer = {
      type: TYPE_QUESTIONS.Text,
      answer: answer,
    }

    onAnswer(userAnswer, {
      hiddenAdditionalInfo: true,
      nextQuestionIndex: allQuestions.findIndex(question => question.id === currentQuestion.id),
      showFeedback: !(currentQuestion.checkAnswer(userAnswer) && !liveActived)
    });

    const isCorrect = currentQuestion.checkAnswer(userAnswer);
    dispatch(setShowBankControl(false));
    if (isCorrect) {
      onChangeEnablePassQuestion(false);
      gameSound.play(MAPA_SOUNDS.CORRECT);
      setHasAcert(true);
      setShowBalloon(false);
      setState(STATE_POINT.CORRECT);
      if (!isLastPointVisited) {
        setShowInfoDialog(true);
        setIsInfoScreenActive(true);
      }

    } else {
      setTimeout(() => {
        setState(STATE_POINT.INCORRECT);

        setTimeout(() => {
          setState(STATE_POINT.DEFAULT);
        }, DELAY_RESET_WRONG_STATE);
      }, DELAY_SHOW_WRONG);
    }

  }

  const onCloseAdittionalInfo = () => {
    if (!isInfoScreenActive) return;
    gameSound.play(MAPA_SOUNDS.CHARGE);
    setState(STATE_POINT.CORRECT);
    setShowInfoDialog(false);
    setIsInfoScreenActive(false);
    dispatch(goToQuestion(nextQuestionIndex));
    dispatch(setShowBankControl(false));
    onChangeEnablePassQuestion(true);

    onClick(null);
  }

  useEffect(() => {
    if (isAllscreenPointsVisited) {
      setTimeout(() => {
        passScreenHandler();
      }, 200);
    }
  }, [isAllscreenPointsVisited, passScreenHandler])

  useEffect(() => {

    const buttonPassHandler = () => {
      if (!showInfoDialog) return;

      gameSound.play(MAPA_SOUNDS.CHARGE);
      setState(STATE_POINT.CORRECT);
      setShowInfoDialog(false);
      setIsInfoScreenActive(false);
      setIsInfoScreenActive(false);
      dispatch(goToQuestion(nextQuestionIndex));
      dispatch(setShowBankControl(false));

      onClick(allQuestions[nextQuestionIndex].id);
      onChangeEnablePassQuestion(true);
    }

    document.addEventListener('clickPassButton', buttonPassHandler);

    return () => {
      document.removeEventListener('clickPassButton', buttonPassHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showInfoDialog]);

  useEffect(() => {
    setIsInputOpen(showInput);
  }, [showInput, setIsInputOpen])

  const pointState = (showInput || showInfoDialog) ? STATE_POINT.FOCUS : state;

  return (
    <>
      <Fill name="modal-top">
        {(showInput && isTouchDevice) && (
          <InputTopWithButtons
            onClose={handleClose}
            onSubmit={submitHandler}
          />
        )}
      </Fill>

      <Fill name="modal">
        {(showInput && !isTouchDevice) && (
          <InputWithButton onSubmit={submitHandler} key="desktopInput" />
        )}
      </Fill>
      <SwipeableDrawerPoint open={showInfoDialog} onClose={onCloseAdittionalInfo}>
        <DialogContent
          mediaType={questionSelected.media?.type}
          media={questionSelected.media?.src}
          title={questionSelected.title}
          description={questionSelected.description}
          explanation={questionSelected.explanation}
        />
      </SwipeableDrawerPoint>

      <Point onClick={clickHandler} disabled={pointDisabled} type={TYPE_POINTS.TEXT} state={pointState} showBalloon={showBalloon} isInfoScreenActive={isInfoScreenActive} />
    </>
  )
}